import { Audiotrack } from '@mui/icons-material';
import * as Sentry from '@sentry/react';
import { Col, Progress, Row } from 'antd';
import { ref as fireRef, getDownloadURL, uploadBytesResumable } from 'firebase/storage';
import { storage } from 'firebaseConfig';
import moment from "moment";
import React, { useState } from 'react';
import { FileUploader } from "react-drag-drop-files";
import styled from 'styled-components';
import { v4 } from 'uuid';

const fileTypes = ["MP3", "WAV", "M4A", "AAC"];


const ImageContainer = styled.div`
    height: auto;
    width:100%;
    display:flex;
    padding-left:24px;
    padding-right:24px;
    margin-bottom:16px;
`;

const FileUploadArea = styled.div`
    height: 100%;
    width:100%;
    border: 1px dashed gray;
    padding: 5px 12px;
    min-height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;
const Column = styled(Col)`
    display: flex;
    justify-content: center;
    align-items: center;
}
`;
const Text = styled.div`
    font-size: 12px;
`;

export default function AudioPicker({ onChange, style , messageText , path, containerStyle}) {
    const [loader, setLoader] = useState(false)
    const [loadingMap, setLoadingMap] = useState(0)

    const handleChange = (file) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        uploadToStorage(file)
        reader.onloadend = function (e) {
            let v = reader.result;
        };
    };
    const uploadToStorage = async (file) => {
        if (file) {
            const location = path ? path : '/books/AudioPicker';
            const id = `${moment().format('YYYY-MM-DD')}-${v4()}`;
            const storageRef = fireRef(storage, `${location}/${id}${file.name}`);
            try {
                const uploadTask = uploadBytesResumable(storageRef, file);
                uploadTask.on('state_changed',
                    (snapshot) => {
                        const per = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                        setLoader(true);
                        setLoadingMap(per);
                    },
                    (error) => {
                        console.error("Upload error:", error);
                        setLoader(false);
                        setLoadingMap(0);
                    },
                    () => {
                        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                            setLoader(false);
                            setLoadingMap(0);
                            onChange(downloadURL);
                        }).catch((error) => {
                            Sentry.captureException(`291 Error getting download URL: ${error}`);
                            console.error("Error getting download URL:", error);
                            setLoader(false);
                            setLoadingMap(0);
                        });
                    }
                );
            } catch (error) {
                console.error("Upload error:", error);
                Sentry.captureException(`292 Error uploading file: ${error}`);
                setLoader(false);
                setLoadingMap(0);
            }
        } else {
            console.log("No file to upload.");
        }
    };
    return (
        <ImageContainer onContextMenu={(e) => { }} style={style}>
            <FileUploader
                handleChange={handleChange}
                name="file"
                classes={"audio-uploader"}
                types={fileTypes}
            >  <FileUploadArea>
                    {loader && <Progress type="line" percent={loadingMap} size={"small"} className={"fileProgress"} showInfo={false} />}
                    <Row className="box box-1" style={{ display: "flex", justifyContent: "space-between" }}>
                        <Column>
                            <Audiotrack color="primary" />
                        </Column>
                        <Column >
                            <Text>
                                {messageText ? messageText : "Upload or drop a file right here"}
                            </Text>
                        </Column>
                        <Column>
                            <Text>
                                {fileTypes.join(", ")}
                            </Text>
                        </Column>
                    </Row>

                </FileUploadArea>
            </FileUploader>
        </ImageContainer>
    )
}
